/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
require('@fancyapps/fancybox');
require('./fontawesome');

window.Headroom = require('headroom.js');
import 'headroom.js/dist/jQuery.headroom'

import { Foundation } from './foundation';
import { WOW } from 'wowjs';
Foundation.addToJquery(jQuery);

/**
 *
 * Application script
 *
 */
$(function() {
    $(document).foundation();

    $('.site-header').headroom({
        classes : {
            // when element is initialised
            initial : "h",
            // when scrolling up
            pinned : "h-pinned",
            // when scrolling down
            unpinned : "h-unpinned",
            // when above offset
            top : "h-top",
            // when below offset
            notTop : "h-not-top",
            // when at bottom of scoll area
            bottom : "h-bottom",
            // when not at bottom of scroll area
            notBottom : "h-not-bottom"
        }
    });

    let menusopen = false,
        $menuSelector = $('#offcanvas'),
        $menuCanvas = new Foundation.OffCanvas($menuSelector, {
            closeOnClick: false
        });

    $('.off-canvas__close-button, .js-off-canvas-overlay').click(function(){
        $('.site-header').removeClass('h-active');
        menusopen = false;
        $menuCanvas.close();
    });
    $('.site-header__navicon').click(function(){
        if (menusopen) {
            if (!Foundation.MediaQuery.atLeast('large')) {
                $menuCanvas.close();
            }
            $('.site-header').removeClass('h-active');
            menusopen = false;
        } else {
            if (!Foundation.MediaQuery.atLeast('large')) {
                $menuCanvas.open();
            }
            $('.site-header').addClass('h-active');
            menusopen = true;
        }
    });

    $('.scroll-to-content').click(function(e){
        e.preventDefault();
        $('html, body').animate(
            {
                scrollTop: $('.header-banner--full').outerHeight()
            },
            500
        );
    });

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       true,             // trigger animations on mobile devices (default is true)
            live:         true,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    wow.init();

    $(window).resize(function(){
        $('[data-sort-order]').each(function(){
            let data = $(this).data('sort-order'),
                position = 0
            for (let size in data) {
                let sort = data[size]
                if (Foundation.MediaQuery.atLeast(size)) {
                    position = sort
                }
            }
            $(this).css('order', position)
        });
    }).resize();


    let gallerynav = $('.gallery-nav'),
        gallery = $('.gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        // asNavFor: '.gallery-nav',
        prevArrow: '<button type="button" class="slick-prev gallery__prev"><i class="fal fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next gallery__next"><i class="fal fa-chevron-right"></i></button>'
    }).on('afterChange', function(event, slick, currentSlide){
        gallerynav.each(function(){
            let offset = $(this).data('gallery-offset');
            $(this).find('[data-gallery-target]').each(function(){
                let pos = $(this).data('gallery-target') + offset;
                if (pos == currentSlide) {
                    $(this).addClass('is-active');
                } else {
                    $(this).removeClass('is-active');
                }
            });
        });
    });

    gallerynav.each(function(){
        let offset = $(this).data('gallery-offset');
        $(this).find('[data-gallery-target]').each(function(){
            let pos = $(this).data('gallery-target') + offset;
            $(this).click(function(){
                gallery.slick('slickGoTo', pos);
            });
        });
    });

    const flickitycontainer = '.flickity-container';
    if ($(flickitycontainer).length) {
        let flkty = new Flickity(flickitycontainer, {
            autoPlay: 3000,
            imagesLoaded: true,
            cellSelector: '.cell',
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false,
            watchCSS: true,
            contain: true
        });
    }
});

// replaces no-js with js class from html tag to help FOUC
(function(H){H.className=H.className.replace(/\bno-js\b/,'js')})(document.documentElement)



// WEBPACK FOOTER //
// ./themes/base/js/app.js